import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component for hover actions (pencil and delete icons)
 */
const HoverActions = ({
  hoveredOver,
  pencilHoveredOver,
  onPencilClick,
  onDeleteTemplate,
  onPencilHoverIn,
  onPencilHoverOut,
  pencilIcon,
  trashIcon,
}) => {
  if (!hoveredOver) return null;

  return (
    <div>
      <div 
        className={`pencil-icon ${pencilHoveredOver ? 'hovered-over' : ''}`}
        onMouseEnter={onPencilHoverIn} 
        onMouseLeave={onPencilHoverOut}
        onClick={onPencilClick}
      >
        <img
          alt="edit" 
          src={pencilIcon} 
          onClick={onPencilClick}
        />
      </div>
      
      <div 
        className={`delete-icon ${pencilHoveredOver ? 'hovered-over' : ''}`}
        onMouseEnter={onPencilHoverIn} 
        onMouseLeave={onPencilHoverOut}
        onClick={onDeleteTemplate}
      >
        <img 
          alt="delete" 
          src={trashIcon} 
          onClick={onDeleteTemplate} 
        />
      </div>
    </div>
  );
};

HoverActions.propTypes = {
  hoveredOver: PropTypes.bool.isRequired,
  pencilHoveredOver: PropTypes.bool.isRequired,
  onPencilClick: PropTypes.func.isRequired,
  onDeleteTemplate: PropTypes.func.isRequired,
  onPencilHoverIn: PropTypes.func.isRequired,
  onPencilHoverOut: PropTypes.func.isRequired,
  pencilIcon: PropTypes.string.isRequired,
  trashIcon: PropTypes.string.isRequired,
};

export default HoverActions;



// WEBPACK FOOTER //
// ./src/containers/ProjectTypesContainer/ProjectTemplateCard/components/HoverActions.js